const o=10;export{o as maxVisualMediaSelectionLimit};
